<template>
  <z-dialogo 
    ref="dialogo" 
    titulo="Configurações" 
    largura="1360px"
    altura="700px" 
    background-color="grey lighten-4"
    dividers 
    scrollable
    hide-actions
  >
    
    <template #conteudo>
      <ConfiguracoesSistema></ConfiguracoesSistema>
    </template>

  </z-dialogo>
</template>

<script setup>
import { ref } from 'vue';
import ConfiguracoesSistema from './ConfiguracoesSistema.vue';

const emits = defineEmits(['abrir', 'fechar']);

const dialogo = ref(null);

function abrir() {
  dialogo.value.abrir();
  emits('abrir');
}

function fechar() {
  dialogo.value.fechar();
  emits('fechar');
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>